export const FIT_DEFAULT = 'cover';
